import Player from "./Player";
import CardManager from "./Cards"
const Buffer = require('buffer').Buffer;
const qs = require('qs');
const httpMessageParser = require('http-message-parser');

const AMAZON_ERROR_CODES = require('./AmazonErrorCodes.js');
const Observable = require('./Observable.js');
// const Player = require('./Player.js');
const arrayBufferToString = require('./utils/arrayBufferToString.js');
const writeUTFBytes = require('./utils/writeUTFBytes.js');
const mergeBuffers = require('./utils/mergeBuffers.js');
const interleave = require('./utils/interleave.js');
const downsampleBuffer = require('./utils/downsampleBuffer.js');
const uuid = require('uuid');
class AVS {

  constructor(options = {}) {
    Observable(this);

    // TODO: temporary work around to mock httpMessageParser
    this._httpMessageParser = httpMessageParser;
    this._bufferSize = 2048;
    this._inputChannels = 1;
    this._outputChannels = 1;
    this._leftChannel = [];
    this._rightChannel = [];
    this._audioContext = null;
    this._recorder = null;
    this._sampleRate = null;
    this._outputSampleRate = 16000;
    this._audioInput = null;
    this._volumeNode = null;
    this._debug = false;
    this._token = null;
    this._refreshToken = null;
    this._clientId = null;
    this._clientSecret = null;
    this._deviceId = null;
    this._deviceSerialNumber = null;
    this._redirectUri = null;
    this._audioQueue = [];
    this._isRecording = false;
    this._micDetected = true;
    this._stream = null;
    this._recordingLength = 0;
    this._avsEndPoints = [];
    this._avsEndPoints['api.amazonalexa.com'] = 'avs-alexa-na.amazon.com';
    this._avsEndPoints['api.fe.amazonalexa.com'] = 'avs-alexa-fe.amazon.com';
    this._avsEndPoints['api.eu.amazonalexa.com'] = 'avs-alexa-eu.amazon.com';
    if (options.token) {
      this.setToken(options.token);
    }

    if (options.refreshToken) {
      this.setRefreshToken(options.refreshToken);
    }

    if (options.clientId) {
      this.setClientId(options.clientId);
    }

    if (options.clientSecret) {
      this.setClientSecret(options.clientSecret);
    }

    if (options.deviceId) {
      this.setDeviceId(options.deviceId);
    }

    if (options.deviceSerialNumber) {
      this.setDeviceSerialNumber(options.deviceSerialNumber);
    }

    if (options.redirectUri) {
      this.setRedirectUri(options.redirectUri);
    }

    if (options.debug) {
      this.setDebug(options.debug);
    }

    this.player = new Player();
    this.cardManager = new CardManager();



    this.player.on(Player.EventTypes.Stop, () => {
      //this._destroyStream();
      this.emit(AVS.EventTypes.FINISH_SPEAK);
    });
  }



  _log(type, message) {
    if (type && !message) {
      message = type;
      type = 'log';
    }

    setTimeout(() => {
      this.emit(AVS.EventTypes.LOG, message);
    }, 0);

    if (this._debug) {
      console[type](message);
    }
  }

  isRecording() {
    return this._isRecording;
  }
  login(options = {}) {
    return new Promise((resolve, reject) => {

      const newWindow = !!options.newWindow;
      const authUrl = options.authUrl;
      if (newWindow) {
        window.open(authUrl);
      } else {
        window.location.href = authUrl;
      }
    });
  }

  logout() {
    var self = this;
    return new Promise((resolve, reject) => {
      self._token = null;
      self._refreshToken = null;
      localStorage.removeItem('token');
      localStorage.removeItem("refreshToken");
      self._log('Logged out');
      resolve();
    });
  }



  /**
   * @default
   */
  getCodeFromUrl() {
    return new Promise((resolve, reject) => {
      const query = qs.parse(window.location.search.substr(1));
      const code = query.code;

      if (code) {
        return resolve(code);
      }

      return reject(null);
    });
  }

  /**
  * @default
  */
  setToken(token) {
    return new Promise((resolve, reject) => {
      if (typeof token === 'string') {
        this._token = token;
        localStorage.setItem("token", token);
        this.emit(AVS.EventTypes.TOKEN_SET);
        this._log('Token set.');
        resolve(this._token);
      } else {
        const error = new TypeError('`token` must be a string.');
        this._log(error);
        reject(error);
      }
    });
  }

  /**
   * @default
   */
  setRefreshToken(refreshToken) {
    return new Promise((resolve, reject) => {
      if (typeof refreshToken === 'string') {
        this._refreshToken = refreshToken;
        localStorage.setItem("refreshToken", refreshToken);
        this.emit(AVS.EventTypes.REFRESH_TOKEN_SET);
        this._log('Refresh token set.');
        resolve(this._refreshToken);
      } else {
        const error = new TypeError('`refreshToken` must be a string.');
        this._log(error);
        reject(error);
      }
    });
  }

    /**
   * @deprecated
   */
  setClientId(clientId) {
    return new Promise((resolve, reject) => {
      if (typeof clientId === 'string') {
        this._clientId = clientId;
        resolve(this._clientId);
      } else {
        const error = new TypeError('`clientId` must be a string.');
        this._log(error);
        reject(error);
      }
    });
  }

  /**
   * @deprecated
   */
  setClientSecret(clientSecret) {
    return new Promise((resolve, reject) => {
      if (typeof clientSecret === 'string') {
        this._clientSecret = clientSecret;
        resolve(this._clientSecret);
      } else {
        const error = new TypeError('`clientSecret` must be a string');
        this._log(error);
        reject(error);
      }
    });
  }

  /**
   * @deprecated
   */
  setDeviceId(deviceId) {
    return new Promise((resolve, reject) => {
      if (typeof deviceId === 'string') {
        this._deviceId = deviceId;
        resolve(this._deviceId);
      } else {
        const error = new TypeError('`deviceId` must be a string.');
        this._log(error);
        reject(error);
      }
    });
  }

  /**
 * @deprecated
 */
  setDeviceSerialNumber(deviceSerialNumber) {
    return new Promise((resolve, reject) => {
      if (typeof deviceSerialNumber === 'number' || typeof deviceSerialNumber === 'string') {
        this._deviceSerialNumber = deviceSerialNumber;
        resolve(this._deviceSerialNumber);
      } else {
        const error = new TypeError('`deviceSerialNumber` must be a number or string.');
        this._log(error);
        reject(error);
      }
    });
  }

  /**
   * @deprecated
   */
  setRedirectUri(redirectUri) {
    return new Promise((resolve, reject) => {
      if (typeof redirectUri === 'string') {
        this._redirectUri = redirectUri;
        resolve(this._redirectUri);
      } else {
        const error = new TypeError('`redirectUri` must be a string.');
        this._log(error);
        reject(error);
      }
    });
  }

  /**
   * @deprecated
   */
  setDebug(debug) {
    return new Promise((resolve, reject) => {
      if (typeof debug === 'boolean') {
        this._debug = debug;
        resolve(this._debug);
      } else {
        const error = new TypeError('`debug` must be a boolean.');
        this._log(error);
        reject(error);
      }
    });
  }

  /**
   * @default
   * @description
   * get the token from AVS object instance.
   */
  getToken() {
    return new Promise((resolve, reject) => {
      const token = this._token;

      if (token) {
        return resolve(token);
      }

      return reject();
    });
  }

  get token() {
    return this._token;
  }

  get refreshToken() {
    return this._refreshToken;
  }

  /**
   * @description
   * Unit test skip
   */
  async requestMic() {
    this._log('Requesting microphone.');

    const constraint = await window.avsWrapper.getConstraintForActiveMicInput(localStorage.getItem('audioPanel_activeDevice'));
    if (!constraint) {
      constraint = { audio: true }
    }
    var self = this;
    const stream = await navigator.mediaDevices.getUserMedia(constraint)

    self._log('Microphone connected.');
    self._micDetected = true;
    self.connectMediaStream(stream);
  }

  getMicDetected() {
    return this._micDetected;
  }

  setMicDetected(value) {
    this._micDetected = value;
  }
  /**
   * @implements
   * Please make sure this method is invoked when you create new AudioContext
   */
  closeCurrentAudioContext() {
    var self = this;
    return new Promise((resolve, reject) => {
      if (self._audioContext) {
        self._audioContext.close().then(function () {
          resolve();
        }).catch(() => {
          reject();
        });
      } else {
        resolve();
      }
    });
  }

  connectMediaStream(stream) {

    var self = this;
    const isMediaStream = Object.prototype.toString.call(stream) === '[object MediaStream]';

    if (!isMediaStream) {
      const error = new TypeError('Argument must be a `MediaStream` object.')
      self._log('error', error)
      self.emit(AVS.EventTypes.ERROR, error);
      return;
    }

    if (stream) {
      console.log(stream.id + "<- latest stream id");
    }

    self._stream = stream;
    self._audioContext = new AudioContext();
    self._sampleRate = self._audioContext.sampleRate;

    self._log(`Sample rate: ${self._sampleRate}.`);

    self._volumeNode = self._audioContext.createGain();
    self._audioInput = self._audioContext.createMediaStreamSource(stream);

    self._audioInput.connect(self._volumeNode);

    var bufferSize = 2048;
    self._recorder = self._audioContext.createScriptProcessor(bufferSize, 1, 1);

    self._recorder.onaudioprocess = function (e) {
      if (!self._isRecording) return;
      var left = e.inputBuffer.getChannelData(0);
      //var right = e.inputBuffer.getChannelData(1);
      self._leftChannel.push(new Float32Array(left));
      // self._rightChannel.push(new Float32Array(right));
      self._recordingLength += bufferSize;
    }

    self._recordingLength += self._bufferSize;


    self._volumeNode.connect(self._recorder);
    self._recorder.connect(self._audioContext.destination);
    self._log(`Media stream connected.`);

  }

  async startRecording() {
    var self = this;
    await self.requestMic();
    if (!self._stream) {
      const error = new Error('No Media Stream connected.');
      self._log('error', error);
      self.emit(AVS.EventTypes.NO_MIC);
      return;
    }
    if (!self._micDetected) {
      const error = new Error('No Media Stream connected.');
      self.emit(AVS.EventTypes.NO_MIC);
      return;
    }
    if (self._stream.getAudioTracks().length > 0 && self._stream.getAudioTracks()[0].muted) {
      const error = new Error('mic off');
      self.emit(AVS.EventTypes.MIC_OFF);
      return;
    }
    self._isRecording = true;
    self._leftChannel.length = self._rightChannel.length = 0;
    self._recordingLength = 0;
    self._log(`Recording started.`);
    self.emit(AVS.EventTypes.RECORD_START);
  }

  _getStream = async () => {
    let stream = null;

    try {
      stream = await navigator.mediaDevices.getUserMedia({
        audio: true,
      });
      this.stream = stream;
    } catch (err) {
      this.stream = null;
      console.log(`Alexa._getStream() - ${err.message}`);
    }

    return stream;
  };

  _destroyStream = () => {
    if (this._audioContext) {
      this._audioContext.close();
      this._audioContext = null;
    }

    if (this._stream) {
      this._stream.getTracks().forEach(track => {
        track.stop();
      });
      this._stream = null;
    }
  };

  stopRecording(isCancel = false) {
    var self = this;
    return new Promise((resolve, reject) => {
      if (!self._isRecording) {
        if (!isCancel)
          self.emit(AVS.EventTypes.RECORD_STOP);
        self._log('Recording stopped.');
        return resolve();
      }

      self._isRecording = false;


      var leftBuffer = mergeBuffers(self._leftChannel, self._recordingLength);

      var interleaved = interleave(leftBuffer);

      interleaved = downsampleBuffer(interleaved, self._sampleRate, self._outputSampleRate);
      /**
       * @description
       * wave file construct.
       * @see https://developer.amazon.com/docs/alexa-voice-service/speechrecognizer.html
       * 1. 16bit Linear PCM (recorder.js covered) OK
       * 2. 16kHz sample rate (recorder.js covered) OK
       * 3. Single channel (recorder.js is using 2, so we changed 2 into 1 for single channel) OK
       * 4. Little endian byte order (setInt16(offset,data,true), true means little endian) OK
       * @see http://soundfile.sapp.org/doc/WaveFormat/
       * to understand wave file structure (rough version).
       * @see http://www-mmsp.ece.mcgill.ca/Documents/AudioFormats/WAVE/WAVE.html
       * to understand wave file structure (specific version).
       * @see https://github.com/mattdiamond/Recorderjs/blob/master/src/recorder.js#L155
       * to go through Sample implementation by Javascript.
       */

      //Init Array buffer. 44 is the RIFF header, interleaved.length * 2 = Subchunk2Size
      //=  NumSamples * NumChannels * BitsPerSample/8 = interleaved.length * 1 * 16 / 8 = interleaved.length * 2
      var buffer = new ArrayBuffer(44 + interleaved.length * 2);
      var view = new DataView(buffer);
      /**
       * File construct START!!!
       * @ref
       * Subchunk1Size = 16 for PCM
       * SubChunk2Size = NumSamples * NumChannels * BitsPerSample/8 = interleaved.length * 1 * 16 / 8 = interleaved.length * 2
       */
      /**
       * @description 1.RIFF identifier (ChunkID)
       */
      writeUTFBytes(view, 0, 'RIFF');
      /**
       * @description RIFF chunk length (ChunkSize)
       * @method 4+(8+SubChunk1Size)+(8+SubChunk2Size)=36+Subchunk2Size
       * This is the size of the entire file in bytes minus 8 bytes for the 
       * two fields not included in this count: ChunkID and ChunkSize.
       */
      view.setUint32(4, 36 + interleaved.length * 2, true);
      /**
       * @description 2.RIFF type (Format)
       * 
       */
      writeUTFBytes(view, 8, 'WAVE');
      /**
       * @description 3.Format chunk identifier (Subchunk1ID)
       * @notice
       * Make sure a space behind 'fmt ', make up 4 bytes.
       */
      writeUTFBytes(view, 12, 'fmt ');
      /**
       * @description 4.Format chunk length (Subchunk1Size)
       * 16 for PCM.
       */
      view.setUint32(16, 16, true);
      /**
       * @description 5.Sample format (raw) (AudioFormat)
       * PCM = 1
       */
      view.setUint16(20, 1, true);
      /**
       * @description 6.Channel count (NumChannels)
       * Mono = 1, Stereo = 2, etc.
       * According to Amazon speech recognizer v2 API specifiction, here should be Mono = 1. 
       */
      view.setUint16(22, 1, true);
      /**
       * @description 7.sample rate (SampleRate)
       * According to Amazon speech recognizer v2 API specifiction, here should be 16kHz = 16000.
       */
      view.setUint32(24, 16000, true);
      /**
       * @description 8.byte rate (sample rate * block align) (ByteRate)
       * SampleRate * NumChannels * BitsPerSample/8 (bits to byte) = 16000 * 1 * 16 / 8 = 16000 * 2
       */
      view.setUint32(28, 16000 * 2, true);
      /**
       * @description 9.block align (channel count * bytes per sample / 8)
       * channel count * bytes per sample / 8 (bits to byte) = 1 * 16 / 8 = 2
       */
      view.setUint16(32, 2, true);
      /** 
       * @description 10.BitsPerSample
       * According to Amazon speech recognizer v2 API specifiction, 16bit Linear PCM means here is 16.
       * @value
       * 16
       */
      view.setUint16(34, 16, true);
      /**
       * @description 11. data chunk identifier(Subchunk2ID)
       * always 4 bytes data.
       */
      writeUTFBytes(view, 36, 'data');
      /**
       * @description 12. data chunk length (Subchunk2Size) 4 bytes
       * SubChunk2Size = NumSamples * NumChannels * BitsPerSample/8 = interleaved.length * 1 * 16 / 8 = interleaved.length * 2. 
       */
      view.setUint32(40, interleaved.length * 2, true);

      const length = interleaved.length;
      const volume = 1;
      let index = 44;
      /**
       * @description 13. add actual data in little endian.
       */
      for (let i = 0; i < length; i++) {
        // let s = Math.max(-1, Math.min(1, interleaved[i]));
        // view.setInt16(index, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
        view.setInt16(index, interleaved[i] * (0x7FFF * volume), true);
        index += 2;
      }
      this._destroyStream();
      self._log(`Recording stopped.`);
      if (!isCancel)
        self.emit(AVS.EventTypes.RECORD_STOP);
      return resolve(view);
    });
  }

  sendWakeWordAudio(data) {
    var self = this;
    self._isRecording = false;
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      var endpoint = this._avsEndPoints[localStorage.getItem('accountLinkingEndpoint')];
      if (typeof endpoint === 'undefined') {
        endpoint = 'avs-alexa-na.amazon.com'
      }
      const url = 'https://' + endpoint + '/v20160207/events';
      console.log('avs url is ' + url);
      xhr.open('POST', url, true);
      xhr.responseType = 'arraybuffer';
      xhr.onload = (event) => {
        const buffer = Buffer.from(xhr.response);

        if (xhr.status === 200) {
          const parsedMessage = this._httpMessageParser(buffer);
          resolve({ xhr, response: parsedMessage });
        } else {
          let error = new Error('An error occured with request.');
          let response = {};

          if (!xhr.response.byteLength) {
            error = new Error('Empty response.');
          } else {
            try {
              response = JSON.parse(arrayBufferToString(buffer));
            } catch (err) {
              error = err;
            }
          }

          if (response.error instanceof Object) {
            if (response.error.code === AMAZON_ERROR_CODES.InvalidAccessTokenException) {
              this.emit(AVS.EventTypes.TOKEN_INVALID);
            }

            error = response.error.message;
          }
          this.emit(AVS.EventTypes.ERROR, error);
          return reject(error);
        }
      };

      xhr.onerror = (error) => {
        this._log(error);
        reject(error);
      };

      const BOUNDARY = '------abcde1234';
      const BOUNDARY_DASHES = '--';
      const NEWLINE = '\r\n';
      const METADATA_CONTENT_DISPOSITION = 'Content-Disposition: form-data; name="metadata"';
      const METADATA_CONTENT_TYPE = 'Content-Type: application/json; charset=UTF-8';
      const AUDIO_CONTENT_TYPE = 'Content-Type: application/octet-stream';
      const AUDIO_CONTENT_DISPOSITION = 'Content-Disposition: form-data; name="audio"';
      var dialogRequestId = localStorage.getItem('dialogRequestId');
      if (typeof dialogRequestId === 'undefined' || dialogRequestId == null) {
        dialogRequestId = uuid.v4()
      }
      else {
        localStorage.removeItem('dialogRequestId');
      }
      const metadata = {

        "context": [
          {
            "header": {
              "namespace": "AudioPlayer",
              "name": "PlaybackState"
            },
            "payload": {
              "token": "",
              "playerActivity": "IDLE",
              "offsetInMilliseconds": "0"
            }
          },
          {
            "header": {
              "namespace": "Alerts",
              "name": "AlertsState"
            },
            "payload": {
              "activeAlerts": [],
              "allAlerts": []
            }
          }
        ],
        "event": {
          "header": {
            "namespace": "SpeechRecognizer",
            "name": "Recognize",
            "messageId": uuid.v4(),
            "dialogRequestId": dialogRequestId
          },
          "payload": {
            "profile": "NEAR_FIELD",
            "format": "AUDIO_L16_RATE_16000_CHANNELS_1",
            "initiator": {
              "type": "WAKEWORD",
              "payload": {
                "wakeWordIndices": {
                  "startIndexInSamples": data.beginIndex,
                  "endIndexInSamples": data.endIndex
                },
                "wakeWord": "ALEXA",
                "token": ""
              },
            }
          },
        }
      };
      console.log(JSON.stringify(metadata))
      const postDataStart = [
        NEWLINE, BOUNDARY_DASHES, BOUNDARY, NEWLINE, METADATA_CONTENT_DISPOSITION, NEWLINE, METADATA_CONTENT_TYPE,
        NEWLINE, NEWLINE, JSON.stringify(metadata), NEWLINE, BOUNDARY_DASHES, BOUNDARY, NEWLINE,
        AUDIO_CONTENT_DISPOSITION, NEWLINE, AUDIO_CONTENT_TYPE, NEWLINE, NEWLINE
      ].join('');

      const postDataEnd = [NEWLINE, BOUNDARY_DASHES, BOUNDARY, BOUNDARY_DASHES, NEWLINE].join('');

      // C# uses List<short> which is Int16
      let dataArray = new Int16Array(data.samples);
      let dataView = new DataView(dataArray.buffer)

      const size = postDataStart.length + dataView.byteLength + postDataEnd.length;
      const uint8Array = new Uint8Array(size);
      let i = 0;

      for (; i < postDataStart.length; i++) {
        uint8Array[i] = postDataStart.charCodeAt(i) & 0xFF;
      }


      for (let j = 0; j < dataView.byteLength; i++, j++) {
        uint8Array[i] = dataView.getUint8(j);
      }

      for (let j = 0; j < postDataEnd.length; i++, j++) {
        uint8Array[i] = postDataEnd.charCodeAt(j) & 0xFF;
      }

      const payload = uint8Array.buffer;

      xhr.setRequestHeader('Authorization', `Bearer ${self._token}`);
      xhr.setRequestHeader('Content-Type', 'multipart/form-data; boundary=' + BOUNDARY);
      this.emit(AVS.EventTypes.TEST_AUDIO_BUFFER, dataView);
      console.log('send request to avs ' + new Date().getTime())
      console.log(new Date());
      xhr.send(payload);
    });
  }

  sendAudio(dataView) {
    var self = this;
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      var endpoint = this._avsEndPoints[localStorage.getItem('accountLinkingEndpoint')];
      if (typeof endpoint === 'undefined') {
        endpoint = 'avs-alexa-na.amazon.com'
      }
      const url = 'https://' + endpoint + '/v20160207/events';
      console.log('avs url is ' + url);
      xhr.open('POST', url, true);
      xhr.responseType = 'arraybuffer';
      xhr.onload = (event) => {
        const buffer = Buffer.from(xhr.response);
        if (xhr.status === 200) {
          const parsedMessage = this._httpMessageParser(buffer);
          resolve({ xhr, response: parsedMessage });
        }
        else {
          let error = new Error('An error occured with request.');
          let response = {};

          if (!xhr.response.byteLength) {
            error = new Error('Empty response.');
          } else {
            try {
              response = JSON.parse(arrayBufferToString(buffer));
            } catch (err) {
              error = err;
            }
          }
          if (response.error instanceof Object) {
            if (response.error.code === AMAZON_ERROR_CODES.InvalidAccessTokenException) {
              this.emit(AVS.EventTypes.TOKEN_INVALID);
            }

            error = response.error.message;
          }

          this.emit(AVS.EventTypes.ERROR, error);
          return reject(error);
        }
      };

      xhr.onerror = (error) => {
        this._log(error);
        reject(error);
      };

      const BOUNDARY = '------abcde1234';
      const BOUNDARY_DASHES = '--';
      const NEWLINE = '\r\n';
      const METADATA_CONTENT_DISPOSITION = 'Content-Disposition: form-data; name="metadata"';
      const METADATA_CONTENT_TYPE = 'Content-Type: application/json; charset=UTF-8';
      const AUDIO_CONTENT_TYPE = 'Content-Type: application/octet-stream';
      const AUDIO_CONTENT_DISPOSITION = 'Content-Disposition: form-data; name="audio"';
      var dialogRequestId = localStorage.getItem('dialogRequestId');
      if (typeof dialogRequestId === 'undefined' || dialogRequestId == null) {
        dialogRequestId = uuid.v4()
      }
      else {
        localStorage.removeItem('dialogRequestId');
      }
      const metadata = {

        "context": [
          {
            "header": {
              "namespace": "AudioPlayer",
              "name": "PlaybackState"
            },
            "payload": {
              "token": "",
              "playerActivity": "IDLE",
              "offsetInMilliseconds": "0"
            }
          },
          {
            "header": {
              "namespace": "Alerts",
              "name": "AlertsState"
            },
            "payload": {
              "activeAlerts": [],
              "allAlerts": []
            }
          }
        ],
        "event": {
          "header": {
            "namespace": "SpeechRecognizer",
            "name": "Recognize",
            "messageId": uuid.v4(),
            "dialogRequestId": dialogRequestId
          },
          "payload": {
            "profile": "NEAR_FIELD",
            "format": "AUDIO_L16_RATE_16000_CHANNELS_1",
            "initiator": {
              "type": "TAP"
            }
          }
        }
      };
      console.log(JSON.stringify(metadata))
      const postDataStart = [
        NEWLINE, BOUNDARY_DASHES, BOUNDARY, NEWLINE, METADATA_CONTENT_DISPOSITION, NEWLINE, METADATA_CONTENT_TYPE,
        NEWLINE, NEWLINE, JSON.stringify(metadata), NEWLINE, BOUNDARY_DASHES, BOUNDARY, NEWLINE,
        AUDIO_CONTENT_DISPOSITION, NEWLINE, AUDIO_CONTENT_TYPE, NEWLINE, NEWLINE
      ].join('');

      const postDataEnd = [NEWLINE, BOUNDARY_DASHES, BOUNDARY, BOUNDARY_DASHES, NEWLINE].join('');

      const size = postDataStart.length + dataView.byteLength + postDataEnd.length;
      const uint8Array = new Uint8Array(size);
      let i = 0;

      for (; i < postDataStart.length; i++) {
        uint8Array[i] = postDataStart.charCodeAt(i) & 0xFF;
      }

      for (let j = 0; j < dataView.byteLength; i++, j++) {
        uint8Array[i] = dataView.getUint8(j);
      }

      for (let j = 0; j < postDataEnd.length; i++, j++) {
        uint8Array[i] = postDataEnd.charCodeAt(j) & 0xFF;
      }

      const payload = uint8Array.buffer;

      xhr.setRequestHeader('Authorization', `Bearer ${self._token}`);
      xhr.setRequestHeader('Content-Type', 'multipart/form-data; boundary=' + BOUNDARY);
      this.emit(AVS.EventTypes.TEST_AUDIO_BUFFER, dataView);
      console.log('send request to avs ' + new Date().getTime())
      xhr.send(payload);
    });
  }

  /**
   * 
   * @obsolete
   */
  audioToBlob(audio) {
    return new Promise((resolve, reject) => {
      const blob = new Blob([audio], { type: 'audio/mpeg' });

      resolve(blob);
    });
  }

  static get EventTypes() {
    return {
      LOG: 'log',
      ERROR: 'error',
      LOGIN: 'login',
      LOGOUT: 'logout',
      RECORD_START: 'recordStart',
      RECORD_STOP: 'recordStop',
      TOKEN_SET: 'tokenSet',
      REFRESH_TOKEN_SET: 'refreshTokenSet',
      TOKEN_INVALID: 'tokenInvalid',
      SPEAKING: 'speaking',
      NO_RESPONSE: 'noResponse',
      REFRESH_PAGE: 'refresh',
      MIC_OFF: 'micoff',
      NO_MIC: 'nomic',
      SHOW_CARD: 'showcard',
      FINISH_SPEAK: 'finishSpeak',
      TRY_LOGIN: 'trylogin',
      CODE_INVALID: 'codeInvalid',
      UPDATE_TOKEN_FAILED: 'updateTokenFailed',
      UPDATE_ACCESS_TOKEN_FAILED: 'updateAccessTokenFailed',
      UPDATE_REFRESH_TOKEN_FAILED: 'updateFreshTokenFailed',
      GET_SHORTCUT: 'getShortcut',
      LOGIN_GUEST: 'guestLogin',
      TOKEN_REFRESH: 'tokenrefresh',
      GET_ALEXA: 'getAlexa',
      GET_THEME: 'getTheme',
      GET_LANGUAGE: 'getLanguage',
      EXPECT_SPEECH: 'expectSpeech',
      TEST_AUDIO_BUFFER: 'testAudioBuffer',
      AUTHENTICATED_SUCCESS: 'authenticatedSuccessfully'
    };
  }

  static get Player() {
    return Player;
  }
}

export default AVS;